<template>
  <b-modal class="import-modal" ref="modal" size="xlg" lazy no-close-on-backdrop no-close-on-esc :hide-header="true"
    :hide-footer="true" :title="getTitle()">
    <template v-slot:modal-title>
      <b-alert show variant="light">
        <strong class="font100">
          {{ this.getTitle() }}
        </strong>

        <b-alert v-if="tab == 'invalid' && order.import_error" class="mt-3 mb-0" show variant="danger">
          <div v-if="order.import_error">
            <i class="fa fa-exclamation-triangle fa-xl mr-2" aria-hidden="true"></i>{{ order.import_error }}
          </div>
        </b-alert>
        <b-alert v-if="verifyCustomForm && !order.import_error" class="mt-3 mb-0" show variant="danger">
          <div>
            <i class="fa fa-exclamation-triangle fa-xl mr-2" aria-hidden="true"></i>{{ err_msg }}
          </div>
        </b-alert>
        <!-- <button @click="hide" type="button" aria-label="Close" class="close">×</button> -->
      </b-alert>
    </template>

    <div class="order-details--modal">
      <LoadingSpinner v-if="isLoading" />
      <Alerts :key="'alerts' + order.id" />
      <b-row>
        <b-col sm="12" lg="6">
          <b-row>
            <b-col>
              <b-row>

                <b-col>
                  <b-card body-class="py-2">
                    <div slot="header">Ship From</div>
                    {{ shipmentOrigin }}
                  </b-card>

                  <b-card body-class="py-2">
                    <div slot="header">Shipping Address</div>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text" :class="['form-control', 'form-control-sm']" placeholder="Order Number"
                            maxlength="25" v-model="order.order_number" @keypress="isNumber($event)"></b-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <b-input type="text" :class="['form-control', 'form-control-sm']" placeholder="Reference ID"
                            maxlength="25" v-model="order.ref_id"></b-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !(toAddress.company || toAddress.first_name || toAddress.last_name) }]"
                            placeholder="Company" v-model="toAddress.company"></b-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !(toAddress.company || toAddress.first_name || toAddress.last_name) || isFullNameRequired }]"
                            placeholder="First Name" v-model="toAddress.first_name"></b-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <b-input type="text"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !(toAddress.company || toAddress.first_name || toAddress.last_name) || isFullNameRequired }]"
                            placeholder="Last Name" v-model="toAddress.last_name"></b-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <GoogleAutoComplete
                            :g-class="['form-control', 'form-control-sm', { 'is-invalid': !toAddress.address || !isAddressValid }]"
                            v-model="toAddress.address" :country="country" @change="onGoogleAddressChange">
                          </GoogleAutoComplete>
                          <!-- <b-input
                            type="text"
                            :class="['form-control', 'form-control-sm']"
                            placeholder="Address1"
                            v-model="toAddress.address"
                          ></b-input> -->
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text" :class="['form-control', 'form-control-sm']"
                            placeholder="Address2 (FL, Apt, Suite, etc.)" maxlength="45" v-model="toAddress.address2">
                          </b-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !toAddress.postal_code || toAddress.postal_code == 0 || checkAddressLineLength }]"
                            placeholder="Postal Code" @change="getCityState(toAddress.postal_code, 'shipto')"
                            v-model="toAddress.postal_code" @keypress="setDirty"></b-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <b-input type="text"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !toAddress.city || checkAddressLineLength }]"
                            placeholder="City" v-model="toAddress.city" @keypress="setDirty"></b-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !toAddress.province || checkAddressLineLength }]"
                            placeholder="State/Province" v-model="toAddress.province" @keypress="setDirty"></b-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <b-form-select :options="countryOptions"
                            id="shipping_country" :class="['form-control', 'form-control-sm', 'custom-select', { 'is-invalid': !toAddress.country }]"
                            placeholder="Country" name="toCountry" v-model="toAddress.country" @change="onChanged" />
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-input type="text" :class="['form-control', 'form-control-sm']" placeholder="Phone Number"
                            v-model="toAddress.phone"></b-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <b-input type="text" :class="['form-control', 'form-control-sm']" placeholder="Email Address"
                            v-model="toAddress.email"></b-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-btn @click="verifyAddress" size="sm" class="btn-light-blue-outline mr-2">
                          <img class="verifyImg" src="/images/icons/verify-address-blue.png">
                          Verify Address
                        </b-btn>
                        <b-btn @click="saveAddress" size="sm" class="btn-light-blue-outline">
                          <img class="verifyImg" src="/images/icons/save-address-blue.png">
                          Save Address
                        </b-btn>
                      </b-col>
                    </b-form-row>
                  </b-card>
                  <b-card body-class="py-2">
                    <div slot="header">
                      Package Details
                      <b-btn v-if="showUpdateRate"
                        :disabled="!showUpdateRateButton || isFieldRequired || verifyCustomForm"
                        class="btn-grad pull-right"
                        style="margin: 2px 0 0 0; background-color: rgb(255, 74, 99); color: white; padding: 2px 8px;"
                        size="xs" @click="updateAndRate">
                        <span v-if="tab == 'invalid' && order.total_price == '0.00'">Get Rate</span>
                        <span v-else>Update Rate</span>
                      </b-btn>
                    </div>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <product-select :disabled="isFieldRequired" :country="country" :product_data="product_data"
                            v-model="selectedProduct" @change="onChangeProduct" @clear="onProductClear"
                            @save="onProductSave"></product-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-select :disabled="isFieldRequired" :options="serviceOptions"
                            :class="['form-control', 'form-control-sm', 'custom-select', { 'is-invalid': !selectedService }]"
                            v-model="selectedService" name="service" @change="onServiceClassChange">
                            <template slot="first">
                              <option :value="''" disabled>Select Service Class</option>
                            </template>
                          </b-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <b-select :options="packageOptions()"
                            :class="['form-control', 'form-control-sm', 'custom-select', { 'is-invalid': !checkPackageType() }]"
                            :disabled="!selectedService || isFieldRequired" v-model="selectedPackage" name="package"
                            @change="setDirty">
                            <template slot="first">
                              <option :value="''" disabled>Select Package Type</option>
                            </template>
                          </b-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col>
                        <b-form-group>
                          <!-- MY PACKAGING -->
                          <b-select :options="dimensionsPresetOptions" :v-model="tmpMyPkg"
                            :disabled="!(dimensionsPresetOptions.length > 1) || isFieldRequired" class="form-control"
                            name="customsContentType" value="0x0x0" @change="onPackagingSelected">
                          </b-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col sm='3'>
                        <label class="p-1">
                          Wgt (lb&amp;oz):
                        </label>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <input type="number" @change="setDirty" :disabled="isFieldRequired" v-model="weight.lb"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !isWeightValid }]" />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <input type="number" @change="setDirty" :disabled="isFieldRequired" v-model="weight.oz"
                            :class="['form-control', 'form-control-sm', { 'is-invalid': !isWeightValid }]" />
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col sm='3'>
                        <label class="p-1">
                          Dim (LxWxH)
                        </label>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <input type="number" class="form-control form-control-sm" placeholder="L"
                            :disabled="isFieldRequired || isDimAllowed" v-model="dimensions.l"
                            @change="onChangeDimensions" />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <input type="number" class="form-control form-control-sm" placeholder="W"
                            :disabled="isFieldRequired || isDimAllowed" v-model="dimensions.w"
                            @change="onChangeDimensions" />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <input type="number" class="form-control form-control-sm" placeholder="H"
                            :disabled="isFieldRequired || isDimAllowed || selectedPackage == 'SOFTPACK'"
                            v-model="dimensions.h" @change="onChangeDimensions" />
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- <div class="row">
            <div class="col-sm-12 d-none">
              <div class="card order-activity">
                <div class="card-header">Order Activity</div>
                <div class="card-body">
                  <ul class="list-group">
                    <li
                      href="#"
                      class="list-group-item list-group-item-action flex-column align-items-start"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Import</h5>
                        <small class="text-muted">{{formatDate(order.created_at)}}</small>
                      </div>
                      <p
                        class="mb-1"
                      >Order {{ order.order_number }} imported from {{ order.marketplace.name }}</p>
                    </li>

                    <li
                      href="#"
                      class="list-group-item list-group-item-action flex-column align-items-start"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Import</h5>
                        <small class="text-muted">{{formatDate(order.created_at)}}</small>
                      </div>
                      <p
                        class="mb-1"
                      >Order {{ order.order_number }} imported from {{ order.marketplace.name }}</p>
                    </li>
                    <li
                      href="#"
                      class="list-group-item list-group-item-action flex-column align-items-start"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Import</h5>
                        <small class="text-muted">{{formatDate(order.created_at)}}</small>
                      </div>
                      <p
                        class="mb-1"
                      >Order {{ order.order_number }} imported from {{ order.marketplace.name }}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> -->
        </b-col>

        <b-col sm="12" lg="6">
          <!-- OPTIONAL FIELDS -->
          <div class="card mb-2">
            <b-card-header class="blue"> Optional Fields </b-card-header>
            <b-card-body>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input-group class="default">
                      <b-form-input type="text" placeholder="Account ID Lookup" size="sm" v-model="acct_id"
                        @keypress.enter="findAcctID" maxlength="100"></b-form-input>
                      <b-input-group-append>
                        <b-btn class="default btn-blue" size="sm" style="opacity: 1; font-size: 11px;" @click="findAcctID"
                          :disabled="!acct_id">
                          <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-form-input type="text" size="sm" placeholder="Description" maxlength="100"
                      v-model="order.description"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-form-input type="text" size="sm" placeholder="Custom Field 1 (Prints on Label)" :maxlength="40"
                      v-model="order.label_sticky"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-form-input type="text" size="sm" placeholder="Custom Field 2 (Prints on Label)" :maxlength="40"
                      v-model="order.label_sticky_2"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-card-body>
          </div>
          <!-- OPTIONAL FIELDS -->

          <div class="card mb-2">
            <div class="card-header blue">Additional Services</div>
            <div class="card-body">
              <b-form-row>
                <b-col>
                  <!-- DELIVERY CONF -->
                  <b-form-group>
                    <b-select class="form-control" v-model="selectedConfirm" :options="signatureOptions"
                      :disabled="!selectedPackage || isFieldRequired" @change="setDirty">
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <!-- DECLARED VALUE -->
                  <b-form-group>
                    <b-form-input :class="['form-control-sm', { 'is-invalid': isInternational && !order.declared_value }]"
                      :disabled="isFieldRequired" v-model="order.declared_value"
                      @keyup.native="(e) => { onKeyUpDeclaredValue(e, null) }" type="number" name="declared-value"
                      :placeholder="!isInternational ? 'Declared Value (Optional)' : 'Declared Value Of All Items'"
                      @change="updateAndRate"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-select class="form-control" v-model="selectedInsurance" @change="updateAndRate"
                      :options="insuranceOptions" :disabled="!selectedPackage || !parseFloat(order.declared_value)">
                      <template slot="first">
                        <option :value=null>None (Default Insurance)</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row >
                <b-col>
                  <b-input-group class="default">
                    <template v-slot:append>
                      <DatePicker class="form-control" :disabled="isFieldRequired" v-model="selectedDate" :config="{
                        widgetPositioning: {
                          horizontal: 'right',
                        },
                        format: 'YYYY-MM-DD',
                        minDate: moment(),
                        maxDate: moment().add('7', 'days'),
                      }" style="font-size: 12px" />
                    </template>
                  </b-input-group>
                  <!-- </b-form-group> -->
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-select class="form-control mt-2" :disabled="isHazmatAllowed || isFieldRequired" v-model="selectedHazmat">
                      <template slot="first">
                        <option :value="null">Hazmat Type (Optional)</option>
                        <option value="Air Eligible Ethanol">Authorized Fragrance and Hand Sanitizer Shipments</option>
                        <option :disabled="isHazmatOptionAllowed" value="Lighters">Authorized Lighters - (Ground Advantage Only)</option>
                        <option value="Div 6.2 Biological Materials">Biological Materials - Lab kits, Authorized COVID Test Kit Returns</option>
                        <option value="Class 8 Air Eligible Corrosive Materials">Cleaning or Tree/Weed Killing Compounds</option>
                        <option value="Class 9 Dry Ice">Dry Ice Package</option>
                        <option value="Class 9 Lithium Battery Unmarked">Electronic Devices Installed With Lithium Batteries (No Marking)</option>
                        <option value="Class 9 Lithium Battery with New Device">Electronic Devices With Lithium Batteries (UN3481 or UN3091)</option>
                        <option value="Excepted Quantity Provision">Excepted Quantity Provision Package - Environmentally Hazardous Materials</option>
                        <option :disabled="isHazmatOptionAllowed" value="Ground Only Hazardous Materials">For Items That Are Not Listed, But Are Restricted To Surface Only - (Ground Advantage Only)</option>
                        <option value="Div 5.1 Hydrogen Peroxide 8 to 20 Percent">Hydrogen Peroxide (8 to 20% Concentration)</option>
                        <option :disabled="isHazmatOptionAllowed" value="Limited Quantity Ground Only">LTD QTY Package - Cosmetics, Cleaning Products, Paints, Gas - (Ground Advantage Only)</option>
                        <option value="Class 9 Magnetized Materials">Magnetized Materials</option>
                        <option :disabled="isHazmatOptionAllowed" value="Div 4.1 Mailable Flammable Solids">Mailable Flammable Solids, Matches - (Ground Advantage Only)</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 9 Lithium Battery Marked Ground Only">Marked Lithium Battery (UN3480 or UN3090) - (Ground Advantage Only)</option>
                        <option value="Consumer Commodity">Non-Flammable Aerosols, Flammable Combustible Liquids, Toxic Substance</option>
                        <option value="Div 5.2 Organic Peroxides">Organic Peroxides Package</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 7 Radioactive Materials">Radioactive Materials, Minerals, Gun sights - (Ground Advantage Only)</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 3">Sanitizer, Alcohol, Flammable Liquids - (Ground Advantage Only)</option>
                        <option value="Class 8 Sealed Lead Acid Battery">Sealed Lead Acid Batteries</option>
                        <option :disabled="isHazmatOptionAllowed" value="Small Quantity Provision">Small Quantity Provision Package - (Ground Advantage Only)</option>
                        <option value="Div 6.1 Toxic Materials">Toxic Materials - Pesticides, Herbicides, etc.</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 1 Toy Propellant or Safety Fuse">Toy Propellant/Safety Fuse - (Ground Advantage Only)</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </div>
          </div>

          <div class="card mb-2" v-show="isInternational">
            <div class="card-header blue">Customs Form</div>
            <div class="card-body">
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-select class="form-control" v-model="customs.content_type" :options="[
                      { value: 'MERCHANDISE', text: 'Merchandise' },
                      { value: 'DOCUMENTS', text: 'Documents' },
                      { value: 'GIFT', text: 'Gift' },
                    ]" :class="['form-control', 'custom-dropdown', { 'is-invalid': !customs.content_type }]">
                      <template slot="first">
                        <option :value="null" disabled>Package Content Type</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-input :class="['form-control', 'form-control-sm', { 'is-invalid': !customs.sender_signature }]"
                    v-model="customs.sender_signature" type="text" name="senderSignature" placeholder="Full Legal Name">
                  </b-input>
                </b-col>
              </b-form-row>

              <b-form-row v-for="(line, i) in lines" :key="i" class="line">
                <b-col cols="3">
                  <b-input v-model="line.quantity"
                    :class="['form-control', 'form-control-sm', { 'is-invalid': !line.quantity }]" type="number"
                    placeholder="Qty" :name="`quantity${i}`"></b-input>
                </b-col>
                <b-col>
                  <b-input :class="['form-control', 'form-control-sm', { 'is-invalid': !line.description }]"
                    v-model="line.description" placeholder="Description (max 50 characters)" maxlength="50"
                    :name="`description${i}`"></b-input>
                </b-col>

                <div class="w-100 mb-2"></div>

                <b-col cols="2">
                  <b-input :class="['form-control', 'form-control-sm', { 'is-invalid': !line.value }]"
                    v-model="line.value" type="number" placeholder="Value ($)" :name="`value${i}`"
                    @input="onCustomValueChange"></b-input>
                </b-col>
                <b-col cols="2">
                  <b-input :class="['form-control', 'form-control-sm', { 'is-invalid': checkCustomWeight(line) }]"
                    type="number" v-model="line.weight1" placeholder="0 (lb)" :name="`weight${i}`"
                    @input="onCustomWeightChange"></b-input>
                </b-col>
                <b-col cols="2">
                  <b-input :class="['form-control', 'form-control-sm', { 'is-invalid': checkCustomWeight(line) }]"
                    type="number" v-model="line.weight2" placeholder="0 (oz)" :name="`weight${i}`"
                    @input="onCustomWeightChange"></b-input>
                </b-col>
                <b-col cols="3">
                  <b-input :class="['form-control', 'form-control-sm', { 'is-invalid': isDeliveryEU && !line.tariff }]" v-model="line.tariff"
                    placeholder="HS Tariff #" :name="`tariff${i}`"></b-input>
                </b-col>
                <b-col cols="3">
                  <b-form-group>
                    <b-form-select id="customsOrigin" :class="['form-control', { 'is-invalid': isDeliveryEU && !line.origin }]" v-model="line.origin" :options="countrySelectOptions"
                      :selected="!line.origin ? 'US' : line.origin" :name="`origin${i}`" />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <div>
                <ul style="margin-left: 5px" class="no-bullets">
                  <li>USPS New Customs Requirements for European Union Countries <a target="_blank" href="https://www.usps.com/international/new-eu-customs-rules.htm">https://www.usps.com/international/new-eu-customs-rules.htm  </a>
                  <div class="hover-text"><i id="second_info" style="color: darkblue; margin-left: 5px" class="fa-solid fa-circle-info"></i>
                    <span class="tooltip-text" id="down">
                      <table style="width:100%">
                        <tr>
                          <td>Austria</td>
                          <td>Belgium</td>
                          <td>Bulgaria</td>
                          <td>Croatia</td>
                        </tr>
                        <tr>
                          <td>Republic of Cyprus</td>
                          <td>Czech Republic</td>
                          <td>Denmark</td>
                          <td>Estonia</td>
                        </tr>
                        <tr>
                          <td>Finland</td>
                          <td>France</td>
                          <td>Germany</td>
                          <td>Greece</td>
                        </tr>
                        <tr>
                          <td>Hungary</td>
                          <td>Ireland</td>
                          <td>Italy</td>
                          <td>Latvia</td>
                        </tr>
                        <tr>
                          <td>Lithuania</td>
                          <td>Luxembourg</td>
                          <td>Malta</td>
                          <td>Netherlands</td>
                        </tr>
                        <tr>
                          <td>Norway</td>
                          <td>Poland</td>
                          <td>Portugal</td>
                          <td>Romania</td>
                        </tr>
                        <tr>
                          <td>Slovakia</td>
                          <td>Slovenia</td>
                          <td>Spain</td>
                          <td>Sweden</td>
                        </tr>
                        <tr>
                          <td>Switzerland</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </table>
                    </span>
                  </div>
                  </li>
                  <li>Finding HS Tariff # by using <a target="_blank" href="https://uscensus.prod.3ceonline.com">US Census Bureau Schedule B Search</a>
                  <div class="hover-text"><i id="second_info" style="color: darkblue; margin-left: 5px" class="fa-solid fa-circle-info"></i>
                    <span class="tooltip-text" id="top">
                      Here’s what an HS number looks like:<br><br>
                      You will need a minimum of <b><u>six digits;</u></b> for example: <b>621142</b><br>
                      <b>•First two numbers:</b> They represent the category of the product, like textiles or electronics.<br>
                      <b>•Middle two numbers:</b> This combination stands for the subcategory of the product, like shirts or shoes.<br>
                      <b>•Last two numbers:</b> They represent the material of the product, like leather.<br><br>
                      It’s important to understand that these codes aren’t unique to each product. For instance, the code 950450 covers video game consoles, table and parlor games, and automatic bowling equipment.
                    </span>
                  </div>
                  </li>
                  <li>Understanding Harmonized System Codes (HS Tariff #) <a target="_blank" href="https://www.trade.gov/harmonized-system-hs-codes">https://www.trade.gov/harmonized-system-hs-codes</a></li>
                </ul>
              </div>
              <div class="w-100">
                <b-btn class="mb-2 w-100" size="sm" variant="danger" v-show="(lines.length > 1)"
                  :disabled="!(lines.length > 1)" @click="deleteLastLine()">Delete last Item</b-btn>

                <b-btn class="mb-2 w-100" size="sm" variant="primary" @click="addLine">Add Additional Item</b-btn>
              </div>
            </div>
          </div>

          <b-card :no-body="true" class="mb-2">
            <div slot="header">Postage Summary</div>
            <table class="table borderless shipping-info mb-0">
              <tbody>
                <tr>
                  <th class="table-green">Shipping Rate:</th>
                  <td>
                    <span :class="rate_style" v-if="rate_msg">{{ rate_msg }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {{ formatPrice(order.rate) }}
                  </td>
                </tr>
                <tr v-if="parseInt(order.surcharge)">
                  <th class="table-green">Surcharge:</th>
                  <td>
                    <span style="color: #dc3545;" v-if="surcharge_msg">{{ surcharge_msg }}
                      &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {{ formatPrice(order.surcharge) }}
                  </td>
                </tr>
                <tr v-for="rateComponent in rateComponents" :key="rateComponent.type">
                  <th class="">{{ rateComponentName(rateComponent) }}:</th>
                  <td class="">{{ rateComponentPrice(rateComponent) }}</td>
                </tr>
                <!-- <tr v-if="user.enable_shipsurance">
                  <th class>Shipsurance:</th>
                  <td>{{ getShipsurance(order.insurance_price) }}</td>
                </tr> -->
                <tr>
                  <th class>Estimated Delivery Date:</th>
                  <td> {{ deliveryEstimate }} </td>
                </tr>
                <tr>
                  <th :class="[!order.total_price || order.total_price == '0.00' ? 'alert-danger' : 'bg-green']">
                    Total Cost:
                  </th>
                  <td :class="[!order.total_price || order.total_price == '0.00' ? 'alert-danger' : 'bg-green']">
                    {{ formatPrice(order.total_price) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>

          <b-card class="buttons mb-2" :no-body="true" v-if="order.order_status_id !== 4">
            <!-- <div slot="header">Actions</div> -->
            <b-card-footer>
              <b-row>
                <b-col sm="6">
                  <b-btn class="w-100" :disabled="!showCloseButton || isFieldRequired" variant="success" size="sm"
                    @click="printLabel">Print Label</b-btn>
                </b-col>
                <b-col sm="6">
                  <b-btn v-if="order.order_status_id !== 5" class="btn-grad w-100 btn-blue"
                    :disabled="!showCloseButton || isFieldRequired" size="sm" @click="hide">Save and Close</b-btn>
                </b-col>
              </b-row>
              <b-row :no-gutters="true" class="mt-1">
                <b-col sm="12">
                  <b-button v-show="!parseInt(order.total_price)" class="w-100 text-white"
                    style="background-color: #858888; border: 1px solid #858888" size="sm" @click="cancel">Cancel
                  </b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>

          <b-card class="mb-0">
            <h6><i class="fa fa-exclamation-circle text-info" aria-hidden="true"></i> Label Requirements:</h6>
            <ol class="mb-0">
              <li>Highlighted fields are required </li>
              <li>Shipping address requirements:
                <ol class="mb-0 pl-4" style="list-style-type: disc">
                  <li>Address line 1 requires a number</li>
                  <li>City, State, Zip must be valid</li>
                </ol>
              </li>
            </ol>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<style lang="scss">
.tooltip-text {
  visibility: hidden;
  position: fixed;
  width: 750px;
  color: white;
  font-size: 12px;
  background-color: #192733;
  border-radius: 10px;
  padding: 10px 15px 10px 15px;
  z-index: 3;
}

.tooltip-text::before {
  content: "";
  position: absolute;
  transform: rotate(45deg);
  background-color: #192733;
  z-index: 1;
}

.hover-text:hover .tooltip-text {
  visibility: visible;
}

#top {
  top: 30%;
  left: 30%;
}

#top::before {
  top: 80%;
  left: 45%;
}

#down {
  top: 30%;
  left: 30%;
}

#down::before {
  top: 80%;
  left: 45%;
}

.hover-text {
  position: absolute;
  display: inline-block;
  font-family: Arial;
  text-align: left;
}
ul.no-bullets {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.import-modal {
  .modal-body {
    max-height: 90vh;
  }

  .modal-dialog {
    max-width: 60vw;
  }
}

.rate-success {
  color: #00b050;
}

.rate-danger {
  color: #dc3545;
}
</style>

<style lang="scss" scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

option:disabled  {
  color: rgb(215, 215, 215) !important;
}

.form-group {
  margin-bottom: 0.5rem !important;
}

.form-control-sm {
  //   height: calc(1.5em + 0.25rem + 2px) !important;
  font-size: 0.75rem;
}

.custom-select {
  height: calc(1.5em + 0.5rem + 2px) !important;
  font-size: 0.75rem;
  padding: 0 1.75rem 0 0.75rem;
}

.card-wrap {
  //display: flex;
}

.card {
  margin-bottom: 15px;
  font-size: 0.75rem;
}

.card-header {
  background-color: #1e88e5;
  color: #fff;
  font-size: 0.95rem !important;
  padding: 0.10rem 1rem;

  * {
    color: #fff;
  }
}

.borderless {

  td,
  th,
  .list-group-item {
    border: none;
  }
}

.order-activity {
  .list-group {
    .list-group-item {
      border-left: none;
      border-right: none;

      &:first-child {
        border-top: none;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.btn-group-vertical {
  width: 100%;
}

.label-info {
  font-size: 13px;

  li {
    padding-left: 10px;
  }
}

.shipping-info td {
  text-align: right;
}
</style>
<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import OrderItems from "../../components/Orders/OrderItems";
import numeral from "numeral";
import Alerts from "../../components/Alerts";
import { mapGetters, mapActions } from "vuex";
import formatters from "../../formatters";
import countries from "../../data/countries";
import moment from "moment";
import insurance from "../../data/insurance";
import sorting from "../../data/sorting";
import cubicWeight from "../../data/cubic-weight";
import Security from "../../mixins/Security";
import DatePicker from "vue-bootstrap-datetimepicker";
// import insurance from "../../data/insurance";
import GoogleAutoComplete from "../../components/GoogleAutoComplete";

export default {
  components: {
    LoadingSpinner,
    OrderItems,
    Alerts,
    DatePicker
  },
  mixins: [
    Security
  ],
  props: ["orderobj", "tab"],
  data() {
    return {
      acct_id: null,
      shipsurance_balance: null,
      dirty: false,
      isLoading: false,
      isGood: true,
      order: this.orderobj,
      rules: null,
      customs: {
        content_type: null,
        sender_signature: "",
        items: []
      },
      lines: [{
        origin: null,
      }], // for customs items
      isWithCustom: false,
      isValueChanged: false,
      isWeightChanged: false,
      err_msg: "",
      isWithCustom: false,
      order_items: [],
      selectedProduct: null,
      surcharge_msg: null,
      rate_style: null,
      rate_msg: null,

      getTitle() {
        return (
          (this.order.marketplace.name + " Order #" + this.order.order_number).toUpperCase()
        );
      },
      getMeta: function (key) {
        if (this.order.metadata.hasOwnProperty(key)) {
          //if( typeof this.order.metadata[key] !== 'undefined' ){
          return this.order.metadata[key];
        }
        return "";
      },
      getShippingPaid: function (shipping_lines, format = false) {
        let total = 0;
        for (let line of shipping_lines) {
          total += parseFloat(line.amount);
        }

        if (format) {
          return this.formatPrice(total);
        }

        return total;
      },
      toAddress: {
        country: "US",
        province: ""
      },
      eu: [ "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","NO","PL","PT","RO","SK","SI","ES","SE","CH"],
      selectedService: "",
      selectedPackage: "",
      selectedConfirm: null,
      getRateTimer: null,
      selectedInsurance: null,
      selectedHazmat: null,
      isDeliveryEU: false,
      selectedDate: "",
      selectedInsuranceInputs: {},
      weight: { lb: 0, oz: 0 },
      dimensions: { l: 0, w: 0, h: 0 },
      delivery_date: null,
      delivery_zone: null,
      tracking_price: 0,
      insurance_price: 0,
      rates: {},
      rate: {},
      formatDate: function (date) {
        return date ? formatters.date(date) : "Unknown";
      }
    };
  },

  async mounted() {
    console.log('order', this.order);
    if (this.order) {
      const {
        shipping_service, package_type,
        total_weight, package_length, package_width, package_height,
        insurance, confirmation, customs_items, items, hazmat,
        shipping_address: { country, address, address2, city, postal_code, first_name, last_name, phone, email, province, company }
      } = this.order;
      let order_items = [];
      items.forEach(item => order_items.push({
        id: item.product_id,
        product_name: item.name,
        sku: item.sku,
        weight: item.weight,
        quantity: item.quantity,
        declared_value: item.price / item.quantity,
      }));
      this.order_items = order_items;
      this.toAddress = Object.assign({}, { country, address, address2, city, postal_code, first_name, last_name, phone, email, province, company });
      console.log('toAddress', this.toAddress);
      this.selectedService = shipping_service.code;
      this.selectedPackage = package_type;
      this.weight = this.getWeight(total_weight);
      this.dimensions = {
        l: package_length,
        w: package_width,
        h: package_height,
      };
      this.selectedInsurance = insurance;
      this.selectedConfirm = confirmation;

      const dim1 = this.order.rate_components.find(v => v.name == 'NonStandardDim1')
      const dim2 = this.order.rate_components.find(v => v.name == 'NonStandardDim2')
      const vol = this.order.rate_components.find(v => v.name == 'NonStandardVol')
      this.surcharge_msg = null;
      if (vol) {
        if (dim1 || dim2) {
          this.surcharge_msg = 'Package length and volume exceeds standard'
        } else {
          this.surcharge_msg = 'Package volumn exceeds 2 cubic feet'
        }
      } else if (dim1) {
        this.surcharge_msg = 'Package length is between 23-30 inches'
      } else if (dim2) {
        this.surcharge_msg = 'Package length exceeds 30 inches'
      }

      if (this.order.customs_sender_signature) {
        this.customs.sender_signature = this.order.customs_sender_signature;
      } else {
        this.customs.sender_signature = this.user.name;
      }
      if (this.order.customs_content_type) {
        this.customs.content_type = this.order.customs_content_type;
      } else {
        this.customs.content_type = 'MERCHANDISE';
      }

      if (customs_items) {
        customs_items.forEach(i => {
          this.lines.push({
            quantity: i.quantity,
            description: i.description,
            value: i.unitPrice,
            weight1: this.getWeight(i.unitWeight.weight).lb || null,
            weight2: this.getWeight(i.unitWeight.weight).oz || null,
            origin: i.origin ? i.origin : "US",
            tariff: i.tariff
          });
        });
      } else {
        items.forEach(i => {
          console.log('item', i);
          let weight = i.weight;
          this.lines.push({
            quantity: i.quantity,
            description: i.name,
            value: i.price,
            weight1: this.getWeight(weight).lb || null,
            weight2: this.getWeight(weight).oz || null,
            origin: "US",
          });
        });
      }
      this.selectedHazmat = hazmat;
    } else {
      this.lines.push({ origin: this.country })
    }
    this.shipsurance_balance = `Shipsurance (Available Balance $${this.user.shipsurance_balance || 0})`

    await this.getRate()
    const docShipping_country = document.getElementById("shipping_country").value
    const eu = this.eu
    if (eu.includes(docShipping_country)) {
      this.isDeliveryEU = true
      this.deleteFirstLine()
    }
  },
  watch: {
    signatureOptions: function (val) {
      this.$nextTick(() => {
        this.onChangeSignatureOptions();
      });
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee: "getEmployeeName",
      getShippingService: "getShippingService",
      shipping_services: "getShippingServices",
      getUserOrigins: "getUserOrigins",
      getSignatureCarrierRules: "getSignatureCarrierRules",
      // getInsuranceCarrierRules: "getInsuranceCarrierRules",
      getServicePackageRules: "getServicePackageRules",
      getCarrierRules: "getCarrierRules",
      products: "products",
      recipients: "recipients",
      shipsurance: "getShipsurance",
    }),
    product_data() {
      return {
        selectedProduct: this.order_items.length ? this.order_items : this.selectedProduct,
        selectedService: this.selectedService,
        selectedHazmat: this.selectedHazmat,
        selectedPackage: this.selectedPackage,
        tmpMyPkg: this.tmpMyPkg,
        weight: this.weight,
        dimensions: this.dimensions
      }
    },
    showUpdateRate() {
      if (this.tab == 'invalid') return true;
      if (this.isAddressValid && this.dirty && (this.weight.lb > 0 || this.weight.oz > 0) && !this.checkAddressLineLength) return true;
      return false;
    },
    totalOrder() {
      const val = parseFloat(this.order.declared_value) || 0;
      const tax = parseFloat(this.order.metadata.total_tax) || 0;
      return val + tax
    },
    countryOptions: countries.getSelectOptions,
    deliveryEstimate() {
      if (!(this.order.estimated_delivery_date || this.order.delivery_zone)) {
        return 'N/A';
      } else {
        const delivery_date = this.order.estimated_delivery_date ? moment(this.order.estimated_delivery_date).format('ddd, MMM D') : 'N/A';
        return `${this.order.delivery_zone ? `Zone ${this.order.delivery_zone} - ` : ''}${delivery_date}`;
      }
    },
    signatureOptions() {
      const rules = this.getSignatureCarrierRules(
        this.selectedService,
        this.selectedPackage,
        this.country,
        false
      );

      // if not
      if (!rules.length) {
        return [{
          value: 'DelCon',
          label: 'Delivery Confirmation (Default Tracking)',
          text: 'Delivery Confirmation (Default Tracking)'
        }];
      }

      let ruleOptions = rules.map(rule => {
        return {
          value: rule.specialServiceId,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
    insuranceOptions() {
      if (_.isEmpty(this.selectedService) || !this.user.shipsurance_terms) {
        return [];
      }
      return insurance.getSelectOptions();

      // Domestic shipment. Just return static options
      if (this.country === "US") {
        return insurance.getSelectOptions();
      }

      // International. Use shipping rules
      let rules = this.$store.getters.getInsuranceCarrierRules(
        this.order.shipping_service.code,
        this.order.package_type,
        this.toAddress.country
      );
      const ruleOptions = rules.map(rule => {
        return {
          value: rule,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
    shipmentOrigin() {
      const company = this.order.origin.company;
      let name = `${this.order.origin.first_name || ''} ${this.order.origin.last_name || ''}`;
      if (company && name.trim()) name = `${name}, ${company}`;
      else if (!name.trim()) name = company;
      return name;
    },

    country() {
      return this.toAddress.country ? this.toAddress.country : "US";
    },

    countrySelectOptions() {
      const cs = countries.getSelectOptions().filter(c => {
        return c.value !== null;
      });
      // _.concat({
      //   text: 'US (Origin)',
      //   value: 'US'
      // }, cs);
      return _.concat({
        text: 'Country of Origin',
        value: null
      }, cs);
    },
    carrierRules: function () {
      return this.getCarrierRules(this.country);
    },
    serviceOptions() {
      try {
        let options = Object.keys(this.carrierRules).map(serviceId => {
          return _.find(this.shipping_services, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(_.filter(options), "order");

        options = options.map(option => {
          let packageOptions = this.packageOptions(option.code);

          // Make sure at least 1 option exists
          if (!packageOptions.length) {
            return null;
          }

          return {
            value: option.code,
            text: option.name
          };
        }).filter(v => v);

        const selectedOption = options.find(o => o.value === this.selectedService);
        if (!selectedOption) this.selectedService = '';

        return options;
      } catch (e) {
        // console.error(e);
        return [];
      }
    },
    confirmation() {
      if (_.isEmpty(this.order.shipping_service)) {
        return null;
      }
      const rules = this.$store.getters.getSignatureCarrierRules(
        this.order.shipping_service.code
      );

      const ruleOptions = rules.map(rule => {
        return {
          value: rule,
          label: rule.brandedName
        };
      });

      return ruleOptions;
    },
    formatted_rate() {
      return this.order.rate ? numeral(this.order.rate).format("$0,0.00") : "$0.00";
    },
    rateComponents() {
      // console.log('Rate Components', this.order.rate_components);
      return this.order.rate_components.filter(r => !['Unknown', 'NonStandardDim1', 'NonStandardDim2', 'NonStandardVol'].includes(r.name))
      // return _.filter(this.order.rate_components, r => r.name !== 'Unknown')
    },
    dimensionsPresetOptions() {
      let options = this.user.dimensions
        ? this.user.dimensions.map(dimension => {
          return {
            value: `${dimension.length}x${dimension.width}x${dimension.height}`,
            text: dimension.name
          };
        })
        : [];

      options = _.concat({
        value: '0x0x0',
        text: 'My Custom Packaging',
      }, options);
      this.tmpMyPkg = '0x0x0';
      return options;
    },
    isAddressValid() {
      return true;
      // if (this.isInternational) return true;
      // const re = /\d/;
      // return re.test(this.toAddress.address)
    },
    isWeightValid() {
      if (this.weight.lb > 0 || this.weight.oz > 0) return true;
      return false
    },
    isInternational() {
      this.isWithCustom = false;
      if (this.toAddress == null) return false;
      console.log("IS International check: ", this.toAddress);
      if (this.toAddress.country.toUpperCase() == 'US') {
        if (["AA", "AE", "AP", "AS", "FM", "GU", "MH", "MP", "PR", "PW", "VI", "UM"].includes(this.toAddress.province.toUpperCase())) { this.isWithCustom = true; return true; }
        return false;
      }
      this.isWithCustom = true;
      return true;
    },
    isFullNameRequired() {
      if (this.isInternational && !this.toAddress.company) {
        return this.toAddress.last_name && this.toAddress.first_name ? false : true;
      }
      return false;
    },
    verifyCustomForm() {
      this.err_msg = "";
      if (!this.isWithCustom) return;
      this.updateCustomItems();
      let total_price = 0,
        total_weight = 0,
        objEmpty = false,
        declaredWeight = parseFloat(((this.weight.lb || 0) * 16) + (this.weight.oz || 0));
      this.customs.items.forEach(function loop(obj) {
        if (loop.stop || typeof (obj) == "undefined") {
          objEmpty = true; return;
        };
        total_price += obj.unitPrice;
        total_weight += obj.unitWeight.weight;
        if (!parseFloat(obj.unitWeight.weight)) {
          total_weight = 0; loop.stop = true;
        } else if (!parseFloat(obj.unitPrice)) {
          total_price = 0; loop.stop = true;
        }
      })
      let errorCount = 0
      let errorLength = 0
      let tariff = ""
      for (let i = 0; i < this.lines.length; i++) {
        if (this.lines[i].tariff == "" || !this.lines[i].tariff) {
          errorCount = errorCount + 1
        }
        if (this.lines[i].origin == null) {
          errorCount = errorCount + 1
        }
        if (this.lines[i].tariff) {
          tariff = this.lines[i].tariff
          if (tariff.length < 6) {
            errorLength = 1
          }
        }
      }
      if (!this.customs.content_type) {
        this.err_msg = "Please select a package content type!";
      }
      else if (!this.customs.sender_signature) {
        this.err_msg = "Please enter full name in custom form!";
      }
      else if (objEmpty) {
        this.err_msg = "Fields that are required can't be empty!";
      }
      else if (this.isValueChanged && total_price && parseFloat(total_price) != parseFloat(this.order.declared_value)) {
        this.err_msg = `Total declared value of additional services does not match total value entered in customs form.`;
      }
      else if (this.isWeightChanged && total_weight && parseFloat(total_weight) != parseFloat(declaredWeight)) {
        this.err_msg = `Total weight of package details does not match total weight e ntered in customs form.`;
      }
      else if (!parseFloat(total_price)) {
        this.err_msg = "Custom form price can't be empty!";
      }
      else if (!parseFloat(total_weight)) {
        this.err_msg = "Custom form weight can't be empty!";
      }
      else if (parseFloat(total_price) != parseFloat(this.order.declared_value)) {
        this.err_msg = `Total declared value of additional services does not match total value entered in customs form.`;
      }
      else if (parseFloat(total_weight) != parseFloat(declaredWeight)) {
        this.err_msg = `Total weight of package details does not match total weight entered in customs form.`;
      }
      else if (this.isDeliveryEU && errorCount) {
        this.err_msg = "Custom form Tariff and Origin can't be empty for EU shipping!";
      }
      if (this.isDeliveryEU && errorLength > 0) {
        this.err_msg = "HS Tariff # should be a minimum of 6 digits";
      }

      if (this.isValueChanged) {
        this.isValueChanged = false;
      }
      if (this.isWeightChanged) {
        this.isWeightChanged = false;
      }
      return (this.err_msg) ? true : false;
    },
    isFieldRequired() {
      if (
        !(this.toAddress.first_name || this.toAddress.last_name || this.toAddress.company) ||
        !this.toAddress.postal_code || !this.toAddress.province || !this.toAddress.city || !this.toAddress.country
      ) return true
      return false
    },
    showCloseButton() {
      if (!this.showUpdateRateButton || !this.order.rate) return false;
      return true;
    },
    showUpdateRateButton() {
      if (!this.isAddressValid || this.err_msg || this.isFullNameRequired || !this.isWeightValid || !this.checkPackageType() || this.checkAddressLineLength) return false;
      return true;
    },
    checkAddressLineLength() {
      let addressLength = 0
      if (this.toAddress.postal_code) {
        addressLength += this.toAddress.postal_code.length
      }
      if (this.toAddress.province) {
        addressLength += this.toAddress.province.length
      }
      if (this.toAddress.city) {
        addressLength += this.toAddress.city.length
      }
      if (addressLength > 45) {
        return true
      }
      return false
    },
    checkDimensions() {
      const { h, w, l } = this.dimensions;
      console.log("hwl", h, w, l);

      const hasAll = h && w && l;
      if (this.selectedPackage === "SOFTPACK") {
        this.dimensions.h = 1
        if (!hasAll) return false;
        return true;
      } else if (this.selectedPackage === "IRRPKG") {
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(h), parseInt(w), parseInt(l)];
        console.log(dim)
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)

        console.log("hasNull", hasNull, "hasVal", hasVal)
        if (hasNull && hasVal) return false
        return true;
      }
    },
    isDimAllowed() {
      console.log('this.selectedPackage', this.selectedPackage);
      if (this.selectedPackage) {
        if (["SOFTPACK", "PKG", "IRRPKG"].includes(this.selectedPackage)) return false;
        this.dimensions.l = null;
        this.dimensions.h = null;
        this.dimensions.w = null;
        return true;
      }
      return false;
    },

    isHazmatAllowed() {
      console.log(this.selectedService)
      if (this.selectedService == "MEDIA") {
        this.selectedHazmat = null
        return true
      }
      else return false
    },
    isHazmatOptionAllowed() {
      console.log(this.selectedService)
      if (this.selectedService == "PM" || this.selectedService == "EM") {
        this.selectedHazmat = null
        return true
      }
      else return false
    },
  },
  methods: {
    ...mapActions(["addPrintJob"]),
    // just added to see ffields
    // showOrders(){
    //   console.log(JSON.stringify(this.order));
    // },
    moment: moment,
    numeral: numeral,
    refresh() { },
    onServiceClassChange(val) {
      this.setDirty()
      this.selectedService = val;
      this.selectedPackage = 'PKG';
      this.selectedInsurance = null;
      this.selectedInsuranceInputs = null;

      switch (val) {
        case "FCPIS":
          const total_weight = ((this.weight.lb || 0) * 16) + (this.weight.oz || 0);
          if (total_weight > 64) {
            this.weight = Object.assign({}, { lb: 0, oz: 0 });
          }
          break;
        case "FCM":
          this.weight.lb = 0;
          break;
      }
    },
    onChangeSignatureOptions() {
      if (_.find(this.signatureOptions, { value: this.selectedConfirm })) {
        return;
      }
      if (
        this.signatureOptions.length === 1 &&
        this.signatureOptions[0].value === null
      ) {
        this.selectedConfirm = null;
      } else if (this.signatureOptions.length > 1) {
        const hasDelCon = _.find(this.signatureOptions, option => {
          return option.value === "DelCon";
        });
        if (hasDelCon) {
          this.selectedConfirm = "DelCon";
        } else if (!_.isNull(this.signatureOptions[0].value)) {
          this.selectedConfirm = this.signatureOptions[0].value;
        } else {
          this.selectedConfirm = this.signatureOptions[1].value;
        }
      } else if (
        this.selectedConfirm === null &&
        this.signatureOptions.length > 0
      ) {
        this.selectedConfirm = this.signatureOptions[0].value;
      } else if (this.signatureOptions.length === 0) {
        this.selectedConfirm = null;
      }
    },
    packageOptions(serviceId = null) {
      try {
        // console.log('package options called');
        let rules = this.$store.getters.getServicePackageRules(
          serviceId || this.selectedService,
          this.country,
          true // filter inactive mail classes
        );
        const flatRates = {
          EM: {
            FRE: "$24.90",
            LGLFRENV: "$25.15",
            PFRENV: "$25.35"
          },
          PM: {
            FRE: "$7.60", // Flat Rate Envelope
            SFRB: "$8.10", // Small Flat Rate Box
            LFRB: "$18.95", // Large Flat Rate Box
            LGLFRENV: "$7.90", // Legal Flat Rate Envelope
            FRB: "$14.00", // Medium Flat Rate Box
            MLFRB: "$18.35", // APO/FPO/DPO
            PFRENV: "$8.30" // Padded Flat Rate Envelope
          }
        };
        // console.log('package options: ' + this.order.shipping_service.code, this.country);
        // console.log(scrules, rules);
        let options = this.order.shipping_service.code ? rules.map(rule => {
          // console.log("RULE", rule);
          let name = rule.brandedName;
          if (
            this.order.shipping_service.code in flatRates &&
            rule.parcelType in flatRates[this.order.shipping_service.code]
          ) {
            name += " - " + flatRates[this.order.shipping_service.code][rule.parcelType];
          }

          return {
            value: rule.parcelType,
            text: name
          };
        })
          : [];

        return options
        // return _.orderBy(options, "text");
      } catch (e) {
        console.error(e);
      }
    },
    async setDirty() {
      // console.log("set dirty");
      this.dirty = true;
      this.order.total_price = 0;
      this.order.rate = 0;
    },
    async onPackagingSelected(val) {
      console.log('mypackaing', val);
      if (!val) return;
      this.tmpMyPkg = val;
      const [l, w, h] = val.split('x');
      // console.log("DIM on change", l,w,h);
      this.dimensions = { l: parseInt(l), w: parseInt(w), h: parseInt(h) };
      this.dirty = true;
    },
    show() {
      this.selectedHazmat = this.order.hazmat
      this.selectedDate = this.order.future_shipping_date
      console.log('showing modal');
      this.$refs.modal.show();
    },
    rateComponentName(rateObj) {
      const sCode = this.order.shipping_service.code;
      switch (sCode) {
        // Priority Mail Express
        case "EM":
          const rateType = rateObj.type;
          if (rateType === "" || rateType === "others") return "Overnight Service";
          return rateObj.name
          break;
        default:
          return rateObj.name
      }
    },
    rateComponentPrice(rateObj) {
      const sCode = this.order.shipping_service.code;
      // console.log('code', sCode);
      let price = 0;
      switch (sCode) {
        // Priority Mail Express
        case "EM":
          const rateType = rateObj.type;
          // for adult signature and delivery confirmation uses "sig" as a type
          if (rateObj.name === "Signature") return "Included";
          else if (rateType === "" || rateType === "others") return "Yes";
          else price = rateObj.value
          break;
        default:
          price = rateObj.value;
      }

      if (price > 0) return this.formatPrice(price);
      else return "None"
    },
    formatPrice: formatters.formatPrice,
    getCountryName: countries.getName,
    getSpecialServiceName(type) {
      const service = this.order.rate_components.find(comp => {
        return comp.type === type;
      });
      return service ? service.name : null;
    },

    printPackingSlip() {
      this.isLoading = true;
      let url = `orders/${this.order.id}/packing_slip?format=b64`;

      axios
        .get(url)
        .then(response => {
          this.isLoading = false;

          // Add to printer
          const decoded = response.data;
          this.addPrintJob({
            label: decoded,
            label_url: `orders/${this.order.id}/packing_slip`,
            type: "pdf"
          });
        })
        .catch(error => {
          let message = error.response.data.message;
          this.$emit("alert", { message: message, type: "danger" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    isRateable() {
      return true;
    },
    update() { },

    saveAddress(e) {
      let vm = this;
      vm.isLoading = true;
      axios
        .post("/orders/" + this.order.id + "/address/save", {})
        .then(response => {
          vm.$refs.modal.$emit("alert", {
            message: response.data.message,
            type: "success"
          });

          vm.order.shipping_address.saved = 1;
        })
        .catch(error => {
          vm.$refs.modal.$emit("alert", {
            message: error.response.data.message,
            type: "danger"
          });
        })
        .finally(() => {
          vm.refresh();
          vm.isLoading = false;
        });
    },
    verifyAddress(e) {
      let address = formatters.address.toPb(this.toAddress);
      this.isLoading = true;
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$refs.modal.$emit("alert", {
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.toAddress = Object.assign({}, this.toAddress, address);
          }
        })
        .catch(e => {
          this.isLoading = false;
          this.$refs.modal.$emit("alert", {
            message:
              address.countryCode === "US"
                ? "Address could not be verified. Please double check address to avoid delay or undeliverable. If label requirements are met, press Get Rate button to be save and close."
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
        });
    },
    // async verifyAddress(e) {
    //   this.isLoading = true;
    //   await this.updateOrder(true);
    //   try {
    //     const response = await axios.post("/orders/" + this.order.id + "/address/verify", {})
    //     this.$refs.modal.$emit("alert", {
    //       message: response.data.message,
    //       type: "success"
    //     });
    //   } catch (error) {
    //     this.$refs.modal.$emit("alert", {
    //       message: error.response.data.message,
    //       type: "danger"
    //     });
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    getWeight(weight) {
      // console.log('getweight', weight);
      return {
        lb: Math.floor(weight / 16),
        oz: Math.round(weight % 16)
      };
    },
    // onChangeInsurance(value) {
    //   this.selectedInsuranceInputs = {};

    //   setTimeout(() => {
    //     this.update();
    //   }, 100);
    // },
    getCityState(zip, ship) {
      if (this.country == 'US') {
        // this.isLoading = true;
        let url = "https://zip.getziptastic.com/v2/US/" + zip;
        // axios.defaults.crossDomain = true;
        var axiosCrossDomain = axios;
        delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
        delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];
        axiosCrossDomain(url, {
          method: "GET"
          // params: {
          //     ...
          // }
        })
          .then(response => {
            //this.toAddress.address2 = response.data.county;
            this.toAddress.city = response.data.city;
            this.toAddress.province = response.data.state_short; q
            this.country = response.data.country;
            this.getRate();
            // this.toAddress.postal_code = response.data.postalCode;
            // console.log(response.data);
          })
          .catch(error => {
            console.log(error.response.data);
          })
        // .finally(() => {
        //   this.isLoading = false;
        // });
      }
    },
    async syncAndRate() {
      try {
        this.isLoading = true;
        // await this.getRate();
        // await this.$nextTick();
        await this.updateOrder();
        this.dirty = false;
      } catch (e) {
        // console.error('sync and rate error: ', e);
        this.$refs.modal.$emit("alert", {
          message: e.message,
          type: "danger"
        });
      } finally {
        this.isLoading = false;
      }
    },

    async updateAndRate() {
      try {
        if (!this.verifyCustomForm) {
          this.isLoading = true
          await this.updateOrder();
          await this.getRate();
          this.dirty = false;
        }
      } catch (e) {
        this.$refs.modal.$emit("alert", {
          message: e.message,
          type: "danger"
        });
      } finally {
        this.isLoading = false;
      }
    },

    async getRate() {
      try {
        this.isLoading = true;
        // console.log('Get Rate');
        this.servicesList = {};
        const { origin } = this.order;
        const fromAddress = {
          addressLines: [origin.address, "", ""],
          cityTown: origin.city,
          stateProvince: origin.state,
          postalCode: origin.postal,
          countryCode: origin.country,
          phone: origin.phone,
          company: origin.company,
          name: origin.first_name + " " + origin.last_name
        };
        const toAddress = {
          addressLines: [this.toAddress.address, "", ""],
          cityTown: this.toAddress.city,
          stateProvince: this.toAddress.province,
          postalCode: this.toAddress.postal_code,
          countryCode: this.toAddress.country,
          phone: this.toAddress.phone
        };
        // console.log('toAddress: ', toAddress);
        let parcel = {
          weight: {
            weight: parseInt(this.weight.lb || 0) * 16 + parseInt(this.weight.oz || 0),
            unitOfMeasurement: 'OZ'
          },
          dimension: {
            length: this.dimensions.l,
            width: this.dimensions.w,
            height: this.dimensions.h,
            unitOfMeasurement: "IN",
            // irregularParcelGirth: 1.0
          }
        };
        // Omit non fully-formed dimensions
        if (!(parcel.dimension.length && parcel.dimension.width && parcel.dimension.height)) {
          parcel = _.omit(parcel, ["dimension"]);
        }

        // if (["SOFTPACK", "IRRPKG"].includes(this.selectedPackage)) {
        //   // don't proceed, we need dim
        //   return;
        // }

        const specialServices = [];
        if (this.toAddress.country === "US") {
          if (this.selectedConfirm) {
            specialServices.push({
              specialServiceId: this.selectedConfirm,
              inputParameters: []
            });
          } else if (this.order.shipping_service.code != 'EM' && !this.selectedConfirm) {
            specialServices.push({
              specialServiceId: 'DelCon',
              inputParameters: []
            });
          }
        }

        let extra = {
          insurance: this.order.insurance,
          declared_value: this.order.declared_value,
          origin_id: origin.id
        };

        if (!_.isEmpty(this.selectedInsurance)) {
          extra.insurance = this.selectedInsurance;

          //   if (this.selectedInsurance !== "parcel-protection") {
          //     let insuranceService = {
          //       specialServiceId: this.selectedInsurance.specialServiceId,
          //       inputParameters: []
          //     };

          //     Object.keys(this.selectedInsuranceInputs).forEach(key => {
          //       insuranceService.inputParameters.push({
          //         name: "INPUT_VALUE",
          //         value: this.selectedInsuranceInputs[key]
          //       });
          //     });

          //     specialServices.push(insuranceService);
          //   }
        }

        let shipmentOptions = [];

        if (this.order.label_sticky) {
          shipmentOptions.push({
            name: "PRINT_CUSTOM_MESSAGE_2",
            value: this.order.label_sticky
          });
        }

        if (this.order.label_sticky_2) {
          shipmentOptions.push({
            name: "PRINT_CUSTOM_MESSAGE_1",
            value: this.order.label_sticky_2
          });
        }

        let rates = [
          {
            carrier: "USPS",
            serviceId: this.order.shipping_service.code,
            parcelType: this.order.package_type,
            inductionPostalCode: this.order.origin.postal_origin,
            specialServices: specialServices
          }
        ];

        if (this.selectedHazmat !== null) {
          rates[0].specialServices.push({
            specialServiceId: "hazmat",
            inputParameters: [
              {
                name: "HAZMAT_TYPE",
                value: this.selectedHazmat
              }
            ]
          });
        }

        const { data } = await axios.post("pb/rate", {
          fromAddress: fromAddress,
          toAddress: toAddress,
          parcel: parcel,
          rates: rates,
          shipmentOptions: shipmentOptions,
          extra
        });

        // this.shipper_addresses = response.data;
        this.rates = data.rates;
        if (data.length > 0) {
          this.rates = data.rates;
        }

        let servicesList = [];
        _.forEach(this.rates, value => {
          const service = _.find(this.services, {
            value: value.serviceId
          });
          if (service) {
            value.name = service.name;
            servicesList.push(value);
          }
          return value;
        });

        this.rate = this.rates[0];

        this.surcharge_msg = null;
        const dim1 = this.rate.specialServices.find(v => v.specialServiceId == 'NonStandardDim1')
        const dim2 = this.rate.specialServices.find(v => v.specialServiceId == 'NonStandardDim2')
        const vol = this.rate.specialServices.find(v => v.specialServiceId == 'NonStandardVol')

        if (vol) {
          if (dim1 || dim2) {
            this.surcharge_msg = 'Package length and volume exceeds standard'
          } else {
            this.surcharge_msg = 'Package volumn exceeds 2 cubic feet'
          }
        } else if (dim1) {
          this.surcharge_msg = 'Package length is between 23-30 inches'
        } else if (dim2) {
          this.surcharge_msg = 'Package length exceeds 30 inches'
        }

        this.rate_msg = null;

        if (this.dimensions.l && this.dimensions.w && this.dimensions.h) {
          const weight = parseInt(this.weight.lb * 16) + parseInt(this.weight.oz);
          let tier = parseFloat(this.dimensions.l * this.dimensions.w * this.dimensions.h / 1728).toFixed(2);
          if (_.inRange(tier, 0, 0.11)) {
            tier = 0.1;
          }
          if (_.inRange(tier, 0.11, 0.21)) {
            tier = 0.2;
          }
          if (_.inRange(tier, 0.21, 0.31)) {
            tier = 0.3;
          }
          if (_.inRange(tier, 0.31, 0.41)) {
            tier = 0.4;
          }
          if (_.inRange(tier, 0.41, 0.51)) {
            tier = 0.5;
          }
          if (this.selectedService === "PRCLSEL") {
            if (_.inRange(tier, 0.51, 0.61)) {
              tier = 0.6;
            }
            if (_.inRange(tier, 0.61, 0.71)) {
              tier = 0.7;
            }
            if (_.inRange(tier, 0.71, 0.81)) {
              tier = 0.8;
            }
            if (_.inRange(tier, 0.81, 0.91)) {
              tier = 0.9;
            }
            if (_.inRange(tier, 0.91, 1.01)) {
              tier = 1.0;
            }
          }

          if (weight <= 320 && this.dimensions.l < 18 && this.dimensions.w < 18 && this.dimensions.h < 18) {
            if (cubicWeight.isCubicWeight(tier, this.rate.destinationZone, this.rate.alternateBaseCharge, this.selectedService)) {
              this.rate_style = 'rate-success';
              this.rate_msg = `Cubic Rate ${tier.toFixed(1)} Activated`;
            }
          }
          if (this.rate.dimensionalWeight.weight) {
            this.rate_style = 'rate-danger';
            this.rate_msg = `DIM Weight Price Activated - ${this.dimensions.l} x ${this.dimensions.w} x ${this.dimensions.h} in`;
          }
        }

        // console.log('Rates', this.rates);
        // console.log('the rate', rate);
        // this.rate = _.find(this.rates, rate => {
        //   return rate.serviceId === this.selectedService;
        // });
        // console.log('the rate', rate);
        // if (rate) {
        //   this.rate = rate;
        //   // await this.$nextTick();
        //   // this.shipping_rate =this.rates[0].alternateBaseCharge;
        //   // this.total_rate =this.rates[0].alternateTotalCharge;
        //   // this.delivery_date = this.rates[0].deliveryCommitment.estimatedDeliveryDateTime || 'N/A';
        //   // this.delivery_zone = this.rates[0].destinationZone;
        // }
      } catch (e) {
        console.log('Rate Error', e);
        throw new Error('Unable to get rate, information provided are invalid.')
      } finally {
        this.isLoading = false
      }
    },
    async updateOrder(verifying_address = false) {
      try {
        // console.log('UPDATE ORDER');
        if (!this.order.id) { return }
        if (this.order.status > 2) { return; }

        this.order.shipping_address = { ...this.toAddress };

        const shippingService = this.getShippingService(this.selectedService);
        this.order.shipping_service_id = shippingService.id;
        this.order.package_type = this.selectedPackage;
        this.order.package_length = this.dimensions.l;
        this.order.package_width = this.dimensions.w;
        this.order.package_height = this.dimensions.h;
        this.order.total_weight = parseInt(this.weight.lb || 0) * 16 + parseInt(this.weight.oz || 0);

        this.order.confirmation = this.selectedConfirm || 'DelCon';
        this.order.special_services = [{
          specialServiceId: this.selectedConfirm || 'DelCon',
          inputParameters: []
        }];

        console.log("Shipping Service Code: ", shippingService.code);
        if ((shippingService.code == "EM" && !this.selectedConfirm) || this.isWithCustom) {
          this.order.special_services = []
          this.order.confirmation = null;
        }

        this.order.order_items = this.order_items.length ? this.order_items : this.selectedProduct ? [this.selectedProduct] : [];
        this.order.insurance = this.selectedInsurance;
        this.order.hazmat = this.selectedHazmat;
        // this.order.tracking_price = this.tracking_price;
        this.order.insurance_price = this.insurance_price;

        if (moment().isBefore(this.selectedDate, "day")) {
          this.order.future_shipping = true
          this.order.future_shipping_date = this.selectedDate
        } else {
          this.order.future_shipping = null
          this.order.future_shipping_date = null
        }

        // console.log("this.order.future_shipping", this.order.future_shipping)
        // console.log("this.selectedDate", this.selectedDate)
        // console.log("this.order.future_shipping_date", this.order.future_shipping_date)

        this.order.customs_items = this.customs.items;
        this.order.customs_sender_signature = this.customs.sender_signature;
        this.order.customs_content_type = this.customs.content_type;

        const data = { ...this.order, is_valid: this.tab };
        console.log('DATA TO UPDATE', data);
        const response = await axios.patch("/orders/" + this.order.id, data)
        this.order = response.data.order;

        this.surcharge_msg = null;
        const dim1 = this.order.rate_components.find(v => v.name == 'NonStandardDim1')
        const dim2 = this.order.rate_components.find(v => v.name == 'NonStandardDim2')
        const vol = this.order.rate_components.find(v => v.name == 'NonStandardVol')

        if (vol) {
          if (dim1 || dim2) {
            this.surcharge_msg = 'Package length and volume exceeds standard'
          } else {
            this.surcharge_msg = 'Package volumn exceeds 2 cubic feet'
          }
        } else if (dim1) {
          this.surcharge_msg = 'Package length is between 23-30 inches'
        } else if (dim2) {
          this.surcharge_msg = 'Package length exceeds 30 inches'
        }
      } catch (error) {
        const { response: { data } } = error;
        if (data) {
          const { errors, order } = data;
          const key = Object.keys(errors);
          this.order = order ? order : null;
          if (!verifying_address) {
            this.$refs.modal.$emit('alert', {
              type: 'danger',
              message: errors[key[0]]
            })
          }
        }
      }
    },
    async onChangeProduct(id) {
      let product = _.find(this.products, p => p.id === parseInt(id));
      this.tmpMyPkg = "0x0x0";
      if (product) {
        this.order_items = [];
        this.dirty = false;
        this.isLoading = true;
        product.quantity = 1;
        this.selectedProduct = product;
        this.selectedService = product.service_class // this.shipping_services.find(s => s.code == product.service_class).id
        this.selectedPackage = product.package_type
        this.weight = this.getWeight(product.weight)
        this.dimensions.l = parseFloat(product.package_length) || null
        this.dimensions.w = parseFloat(product.package_width) || null
        this.dimensions.h = parseFloat(product.package_height) || null
        this.order.declared_value = parseFloat(product.declared_value) || null

        if (product.service_class == 'EM') {
          this.selectedConfirm = 'Sig'
        } else {
          this.selectedConfirm = 'DelCon'
        }

        if (this.showUpdateRateButton && !this.isFieldRequired) {
          await this.updateOrder();
          await this.getRate();
        }
        this.isLoading = false;
      }
    },
    onProductClear() {
      this.order_items = [];
      this.selectedProduct = null;
      this.selectedService = "";
      this.selectedPackage = "";
      this.order.declared_value = null;
      this.tmpMyPkg = "0x0x0";
      this.weight = { lb: null, oz: null };
      this.dimensions = { l: null, w: null, h: null };
      this.setDirty();
    },
    async onProductSave(data) {
      this.isLoading = true;
      this.order_items = data.selectedProduct
      this.selectedService = data.selectedService;
      this.selectedPackage = data.selectedPackage;
      this.order.declared_value = data.declaredValue;
      this.tmpMyPkg = data.tmpMyPkg;
      this.weight = data.weight;
      this.dimensions = data.dimensions
      if (this.selectedService !== 'FCM') {
        this.noLB = false;
      }
      if (this.showUpdateRateButton && !this.isFieldRequired) {
        await this.updateOrder();
        await this.getRate();
      }
      this.isLoading = false;
    },
    async onChanged() {
      this.setDirty()
      const coo = document.getElementById("customsOrigin");
      if(coo.value.length > 0){
        coo.style.color = "#495057"
      }
      else{ coo.style.color = "#696868"} 

      this.isDeliveryEU = false;
      if(this.eu.includes(this.toAddress.country)){      
        this.isDeliveryEU = true;
      }
    },
    async onGoogleAddressChange(addr) {
      // console.log('Addr', addr);
      this.toAddress = Object.assign({}, this.toAddress, addr);
      this.setDirty();
    },
    async hide() {
      // this.$refs.modal.hide();
      console.log('hiding modal');
      await this.syncAndRate()
      this.$emit("saveAndClose");
    },
    async cancel() {
      this.$emit("cancel");
    },
    async printLabel() {
      // console.log("print label clicked")
      // this.$emit('print', this.order.id, {
      //   paper: "DOC_4X6",
      //   bName: Date.now(),
      // });
      // this.$router.push('/orders/batch-label-history');
      await this.updateOrder();
      this.$emit("print", this.order.id);
    },
    checkPackageType() {
      const hasPackage = this.packageOptions().find(e => e.value === this.selectedPackage)
      if (!hasPackage) {
        this.selectedPackage = "";
        return false;
      }
      return true;
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      const keyCodes = [45, 109, 189];
      let order_number = this.order.order_number;
      if (!order_number && keyCodes.includes(charCode)) {
        evt.preventDefault();
      } else if (order_number && order_number.slice(-1) === '-' && keyCodes.includes(charCode)) {
        evt.preventDefault();
      } else if (!keyCodes.includes(charCode) && (charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // async printLabel(type = null) {
    //   if (type !== "return") {
    //     try {
    //       let dialog = await this.$dialog.confirm(
    //         "Are you sure you want to reprint this label?"
    //       );
    //       dialog.close();
    //     } catch (e) {
    //       return;
    //     }
    //   }

    //   if (type === "return") {
    //     try {
    //       let dialog = await this.$dialog.confirm(
    //         "Ship and From address will be inverted. Your account will only be charged once the label is scanned into the USPS mail stream."
    //       );
    //       dialog.close();
    //     } catch (e) {
    //       return;
    //     }
    //   }

    //   let url = "printlabel/" + this.order.id;
    //   if (type === "return") {
    //     url += "/return";
    //   }
    //   axios
    //     .post(`${url}?format=b64`)
    //     .then(response => {
    //       // this.shipper_addresses = response.data;
    //       this.isLoading = false;
    //       //this.order.label_print = response.data.documents[0].contents;

    //       // Add to printer
    //       const decoded = {
    //         label: response.data.label,
    //         label_url: response.data.label_url,
    //         type: type
    //       };
    //       //const decoded = atob(response.data.label)
    //       this.addPrintJob(decoded);
    //       //window.open(response.data.label);
    //     })
    //     .catch(error => {
    //       console.log("nooo", error);
    //       this.isLoading = false;
    //       let message = error.response.data.message;
    //       if (error.response.data.errors) {
    //         message += ": ";
    //         message += Object.values(error.response.data.errors).join(" ");
    //       }
    //       this.$emit("alert", { message: message, type: "danger" });
    //       // alert(JSON.parse(error.response.data.message)[0].additionalInfo);
    //     });
    // },

    getShipsurance(insurance) {
      console.log('getting insurance', insurance);
      if (insurance) return `$${insurance}`
      return 'N/A'
    },

    // togglePostmark() {
    //   this.order.future_shipping_date = moment();
    //   this.dirty = false;
    //   // this.$nextTick(() => {
    //   //   console.log('order.future_shipping', this.order.future_shipping);
    //   // })
    // },

    async onChangeDimensions() {
      await this.setDirty()
      console.log('onDimension changed called');
      const status = this.checkDimensions;
      // if(status !== false && (this.weight.lb || this.weight.oz )){
      //   await this.$nextTick();
      //   if (!this.dim_set){
      //     await this.getRate();
      //   }
      //   if(this.dim_set){
      //     console.log("set dw_set to true via weight change")
      //     this.dw_set = true;
      //   }
      //   console.log("dw_set value via dimension", this.dw_set);
      //   this.dim_set = true;
      // }
    },

    onKeyUpDeclaredValue(e, rule) {
      clearTimeout(this.getRateTimer);
      let val = e.target.value;
      this.declaredValue = val;
      if (!val) {
        this.selectedInsurance = null;
        this.selectedInsuranceInputs[rule.brandedName] = 0;
        this.getRate();
      } else if (rule && val >= rule.minValue && val <= rule.maxValue) {
        this.getRateTimer = setTimeout(() => {
          this.getRate();
        }, 250);
      }
    },

    async onChangeRecipient(id) {
      id = parseInt(id);
      let address = _.find(this.recipients, address => {
        return address.id === id;
      });
      if (address) {
        this.toAddress = address;
        this.acct_id = address.acct_id
      }
      this.dw_set = false;
      this.getRate();
    },

    async findAcctID() {
      if (!this.acct_id) return

      try {
        const { data: { id } } = await axios.get(`/addresses/${this.acct_id}`);
        if (id) {
          await this.onChangeRecipient(id)
        } else {
          throw new Error("Acct ID not found")
        }
      } catch (e) {
        this.$refs.modal.$emit("alert", {
          message: "Address not found with the Account ID provided!",
          type: "danger"
        });
      }
    },
    addLine() {
      this.lines.push({ origin: this.country, unitPrice: 0 });
      this.updateCustomItems();
    },
    deleteLastLine() {
      if (this.lines.length > 1) {
        this.lines = this.lines.splice(0, this.lines.length - 1);
        this.updateCustomItems();
      }
    },
    deleteFirstLine() {
      // console.log("this.lines", this.lines)
      this.lines.shift();
    },
    updateCustomItems() {
      this.customs.items = this.lines.map(line => {
        if (line.quantity && line.description) {
          const lb = line.weight1 ? parseInt(line.weight1) * 16 : 0;
          const oz = line.weight2 ? parseInt(line.weight2) : 0;
          return {
            quantity: parseInt(line.quantity),
            description: line.description,
            unitPrice: parseFloat(line.value),
            tariff: line.tariff,
            unitWeight: {
              weight: lb + oz,
              unitOfMeasurement: "OZ",
            },
            originCountryCode: line.origin
          }
        }
      });
    },
    onCustomValueChange() {
      this.isValueChanged = true;
    },
    onCustomWeightChange() {
      this.isWeightChanged = true;
    },
    onOrderWeightChange() {
      this.isWeightChanged = true;
    },

    checkCustomWeight(line) {
      if (!line.weight1 && !line.weight2) {
        return true
      }
      return false
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/ShowImportModal.vue